import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    cdpStaticDetail: [],
    cdpStatisticDetailFlag: undefined,
    cdpStatisticGroup: [],
    // cdpStatisticGroupMessageCount: 0,
    cdpGroupings: {
        cdpGroup: [
            'hour',
            'day',
            'week',
            'month',
        ],
        cdpGroupByOptionally: [
            'partner',
            'broker_account_login',
            'event_type',
            'ext_event_profile_id',
            'ext_campaign_id',
            'connection_type',
            'partner_user_login',
            'server_info'
        ],
    },
};


export const cdpStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
